<template>
  <v-container fluid grid-list-md text-xs-center style="min-height: 93.4vh">
    <v-layout row wrap>
      <v-toolbar scroll-target="#scrolling-home" class="my-workshop-toolbar">
        <v-layout>
          <v-flex xs2 class="centerContent">
            <v-toolbar-title>
              <div class="centerContent">
                <div class="d-inline-block">Talleres</div>
              </div>
            </v-toolbar-title>
          </v-flex>
          <v-flex xs10 style="padding: 10px">
            <v-layout wrap row class="centerContent">
              <v-flex xs3 class="padding-flex">
                <v-layout>
                  <v-flex class="titleSearch">
                    <v-text-field
                      flat
                      label="Buscar: título / descripción"
                      append-outer-icon="search"
                      @click:append-outer="filterSearch"
                      @click:clear="filterSearchClear"
                      @keyup.enter="filterSearch"
                      solo-inverted
                      v-model="filters.search"
                      clearable
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs3 class="padding-flex">
                <v-autocomplete
                  v-model="filters.employee"
                  :items="collaborators"
                  :item-text="employeeText"
                  item-value="id"
                  label="Colaborador"
                  @change="filterSearch"
                  required
                />
              </v-flex>
              <v-flex xs3 class="padding-flex">
                <v-autocomplete
                  v-model="filters.classroom"
                  :items="classRooms"
                  :item-text="classRoomText"
                  item-value="classroomId"
                  label="Salón"
                  @change="filterSearch"
                  required
                />
              </v-flex>
              <v-flex xs3 class="padding-flex">
                <v-layout>
                  <v-flex class="titleSearch">
                    <v-text-field
                      flat
                      label="Buscar: tag"
                      append-outer-icon="search"
                      @click:append-outer="filterSearch"
                      @click:clear="filterSearchClearTag"
                      @keyup.enter="filterSearch"
                      solo-inverted
                      v-model="filters.tag"
                      clearable
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout wrap row>
              <v-flex xs4>
                <v-menu
                  v-model="modalF"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      id="first"
                      :value="momentFormatFirst"
                      label="Fecha de inicio"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    header-color="primary"
                    color="secondary"
                    locale="es-419"
                    v-model="timeFirst"
                    scrollable
                  />
                </v-menu>
              </v-flex>
              <v-flex xs4 class="padding-flex">
                <v-menu
                  v-model="modalL"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      id="first"
                      :value="momentFormatLast"
                      label="Fecha final"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    header-color="primary"
                    color="secondary"
                    locale="es-419"
                    v-model="timeLast"
                    scrollable
                  />
                </v-menu>
              </v-flex>
              <v-flex xs4 class="padding-flex">
                <v-select
                  @input="filterStatus"
                  :items="status"
                  v-model="filters.statusWorkshops"
                  item-text="text"
                  multiple
                  label="Estatus"
                >
                  <template v-slot:selection="{ item, index }">
                    <span v-if="index < 2">{{ item.text }}, &nbsp;</span>
                    <span v-if="index === 2" class="grey--text caption"
                      >(+{{ filters.statusWorkshops.length - 2 }} más)</span
                    >
                  </template>
                </v-select>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-tooltip right>
          <v-btn
            color="gradiente"
            dark
            small
            absolute
            bottom
            left
            fab
            slot="activator"
            @click="
              modals.createWorkshop = true
              workshopEditObject = undefined
            "
          >
            <v-icon>add</v-icon>
          </v-btn>
          <span>Crear taller</span>
        </v-tooltip>
      </v-toolbar>
      <v-container
        fluid
        elevation-2
        style="max-height: 75vh"
        class="scrollDesign"
        grid-list-md
      >
        <v-layout row wrap>
          <v-flex>
            <v-data-iterator
              :pagination.sync="pagination"
              :total-items="totalWorkshops"
              :items="workshops"
              :rows-per-page-items="[9, 18, 27]"
              item-key="id"
              content-tag="v-layout"
              :no-data-text="workshops.length > 0 ? '' : 'No hay talleres'"
              no-results-text="No hay comunicados"
              rows-per-page-text="Registros por página"
              row
              wrap
            >
              <template v-slot:item="props">
                <v-flex xs12 sm8 md8 lg4 xl4 style="height: 200px">
                  <v-hover v-slot="{ hover }">
                    <v-card
                      :elevation="hover ? 16 : 2"
                      class="elevation-0 card-workshop"
                    >
                      <v-layout row wrap class="layout-workshop">
                        <v-flex sm4 md4 lg4 class="image-content">
                          <div class="image-parent">
                            <div class="image-view">
                              <div
                                v-if="
                                  props.item.imageStorage !== undefined &&
                                  props.item.imageStorage.length > 0
                                "
                                :style="{
                                  backgroundImage:
                                    'url(' +
                                    props.item.imageStorage[0].miniObjUrl +
                                    ')',
                                }"
                                class="image-workshop"
                              />

                              <v-img
                                v-else
                                :src="
                                  require('@/assets/notices/SKLB-Aviso 3.png')
                                "
                                @click="props.expanded = !props.expanded"
                                class="image-workshop-default"
                              />
                            </div>

                            <div class="status-content">
                              {{ getStatus(props.item) }}
                            </div>
                          </div>
                        </v-flex>
                        <v-flex sm8 md8 lg8 class="data-content">
                          <div class="data-content-text">
                            <div class="title">
                              {{ props.item.name }}
                            </div>
                            <div class="my-nowrap subtitle-1">
                              {{ getInscriptionDate(props.item) }}
                            </div>
                            <!-- <div
                              class="my-nowrap subtitle-1"
                            >
                              {{ getEmployeeName(props.item) }}
                            </div> -->
                            <div class="my-nowrap subtitle-2">
                              {{ 'Días a impartir: ' + getDays(props.item) }}
                            </div>
                            <!-- <div
                              class="my-nowrap description"
                            >
                              {{ getEnrollmentData(props.item) }}
                            </div> -->
                            <div class="my-nowrap description">
                              {{ 'Clasificación: ' + props.item.tag }}
                            </div>
                          </div>
                          <div class="data-content-actions mt-1">
                            <v-layout class="full-content">
                              <v-flex v-if="showAddUser(props.item)">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      class="icon"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="addUser(props.item)"
                                    >
                                      person_add
                                    </v-icon>
                                  </template>
                                  <span>Añadir alumnos</span>
                                </v-tooltip>
                              </v-flex>
                              <v-flex v-if="showBlockWorkshop(props.item)">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      class="icon"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="disableWorkshop(props.item)"
                                    >
                                      block
                                    </v-icon>
                                  </template>
                                  <span>Deshabilitar taller</span>
                                </v-tooltip>
                              </v-flex>
                              <v-flex v-if="showEditButton(props.item)">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      class="icon"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="editWorkshop(props.item)"
                                    >
                                      edit
                                    </v-icon>
                                  </template>
                                  <span>Editar taller</span>
                                </v-tooltip>
                              </v-flex>
                              <v-flex>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      class="icon"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="seeDetails(props.item)"
                                    >
                                      more_horiz
                                    </v-icon>
                                  </template>
                                  <span>Ir a detalle</span>
                                </v-tooltip>
                              </v-flex>
                              <v-flex v-if="showDeleteUser(props.item)">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      class="icon"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="deleteWorkshop(props.item)"
                                    >
                                      delete
                                    </v-icon>
                                  </template>
                                  <span>Eliminar taller</span>
                                </v-tooltip>
                              </v-flex>
                            </v-layout>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-hover>
                </v-flex>
              </template>
              <!-- <template
                v-slot:pageText="props"
              >
              </template> -->
            </v-data-iterator>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
    <create-workshop
      v-model="modals.createWorkshop"
      :workshopEdit="workshopEditObject"
      @close="closeCreateWorkshop"
    />
    <enrolled-student
      v-model="modals.enrolledStudent"
      :workshopEdit="workshopEditObject"
      :isEnrolled="isEnrolled"
      @close="closeDetails"
    />
    <simple-confirm
      v-model="confirmDialog"
      :message="messageConfirm"
      @save="confirmSave"
    />
    <success v-model="toast.success" :text="messageError" />
    <error v-model="toast.failed" text="Ups ocurrió un error" />
    <loading text="Trabajando..." v-model="toast.loading" />
  </v-container>
</template>
<script>
import moment from 'moment'

import { ableDays } from '@/Catalogs/mapSettings'
import { mapGetters } from 'vuex'
import { getMessageError, isEmptyOrNull } from '../../../plugins/GeneralMethods'
import Error from '../../Dialogs/Error.vue'
import Loading from '../../Dialogs/Loading.vue'
import Success from '../../Dialogs/Success.vue'
import CreateWorkshop from '../../Modals/workshops/CreateWorkshop.vue'
import EnrolledStudent from '../../Modals/workshops/EnrolledStudent.vue'
import SimpleConfirm from '../../Modals/workshops/SimpleConfirm.vue'

export default {
  components: {
    CreateWorkshop,
    EnrolledStudent,
    SimpleConfirm,
    Success,
    Error,
    Loading,
  },
  data: () => ({
    modals: {
      createWorkshop: false,
      enrolledStudent: false,
    },
    workshops: [],
    workshopEditObject: {},
    isEnrolled: null,
    messageConfirm: '',
    confirmDialog: false,
    toast: {
      success: false,
      failed: false,
      loading: false,
    },
    filters: {
      search: '',
      tag: '',
      dates: [],
      typeNotice: [],
      //nuevas variables v2
      statusWorkshops: [],
      classroom: '',
      offset: 0,
      size: 9,
      employee: '',
    },
    classRooms: [],
    dateMenu: false,
    dates: [],
    allowedDates: [],
    dateMenu2: false,
    dates2: [],
    allowedDates2: [],
    modalF: false,
    modalL: false,
    timeFirst: moment(
      new Date(new Date().getFullYear(), new Date().getMonth(), 1)
    ).format('YYYY-MM-DD'),
    timeLast: moment().format('YYYY-MM-DD'),
    collaborators: [],
    pagination: {},
    totalWorkshops: 0,
    status: [],
    defaultStatus: ['C', 'P', 'A', 'F'],
    isFirsPagination: true,
    messageError: 'Ups, occurió un error',
  }),
  mounted() {
    this.applyFilters()
    if (this.getBranch.id != null) {
      this.getClassRooms()
      this.getWorkshops()
      this.getEmployees()
    }
  },
  watch: {
    timeFirst() {
      this.getWorkshops()
      this.modalF = false
    },
    timeLast() {
      this.getWorkshops()
      this.modalL = false
    },
    getBranch() {
      if (this.getBranch.id != null) {
        this.getClassRooms()
        this.getWorkshops()
        this.getEmployees()
      }
    },
    pagination: {
      handler() {
        if (!this.isFirsPagination) {
          this.getWorkshops()
        } else {
          this.isFirsPagination = false
        }
      },
      deep: true,
    },
  },
  computed: {
    momentFormatFirst() {
      if (this.timeFirst != null) {
        return moment(this.timeFirst).format('DD/MM/YYYY')
      }
      return ''
    },
    momentFormatLast() {
      if (this.timeLast != null) {
        return moment(this.timeLast).format('DD/MM/YYYY')
      }
      return ''
    },
    ...mapGetters(['getBranch']),
  },
  methods: {
    showEditButton(workshop) {
      const status = workshop.status
      if (status === 'A' || status === 'C') return true
      return false
    },
    showAddUser(workshop) {
      const status = workshop.status
      if (status === 'A' || status === 'C') return true
      return false
    },
    showDeleteUser(workshop) {
      const status = workshop.status
      if (status === 'C') return true
      return false
    },
    showBlockWorkshop(workshop) {
      const status = workshop.status
      if (status === 'A') return true
      return false
    },
    getEmployees() {
      const payload = {}
      payload.size = 1000
      payload.offset = 0

      this.$store
        .dispatch('employee/getEmployees', payload)
        .then((response) => {
          this.collaborators = response.data.data
        })
        .catch(() => {
          this.collaborators = []
        })
    },
    classRoomText(classRoom) {
      return classRoom.classroomName
    },
    employeeText(collaborator) {
      return collaborator.firstName + ' ' + collaborator.lastName
    },
    getClassRooms() {
      const body = {
        search: '',
        offset: 0,
        size: 100,
      }
      this.$store
        .dispatch('classRoom/getClassrooms', body)
        .then((response) => {
          this.classRooms = response.data.entity
        })
        .catch((response) => {
          this.messageError = getMessageError(response.data)
          this.toast.failed = true
          this.classRooms = []
        })
    },
    closeDetails() {
      this.isEnrolled = null
      this.workshopEditObject = null
    },
    addUser(workshop) {
      console.log('addUser')
      this.isEnrolled = true
      this.modals.enrolledStudent = true
      this.workshopEditObject = workshop
    },
    seeDetails(workshop) {
      this.isEnrolled = false
      this.modals.enrolledStudent = true
      this.workshopEditObject = workshop
    },
    disableWorkshop(workshop) {
      if (this.toast.loading == false) {
        var objc = JSON.parse(JSON.stringify(workshop))
        objc.status = 'I'
        this.toast.loading = true
        this.$store
          .dispatch('workshop/updateWorkshop', objc)
          .then(() => {
            this.toast.success = true
            this.toast.loading = false
            this.getWorkshops()
          })
          .catch((response) => {
            this.messageError = getMessageError(response.data)
            this.toast.loading = false
            this.toast.failed = true
          })
      }
    },
    editWorkshop(workshop) {
      this.workshopEditObject = workshop
      if (!isEmptyOrNull(this.workshopEditObject.strEndDate)) {
        this.workshopEditObject.strEndDate += ' 12:00:00'
      }
      if (!isEmptyOrNull(this.workshopEditObject.strStartDate)) {
        this.workshopEditObject.strStartDate += ' 12:00:00'
      }
      this.modals.createWorkshop = true
    },
    deleteWorkshop(workshop) {
      this.confirmDialog = true
      this.workshopEditObject = workshop
      this.messageConfirm =
        '¿Estas seguro de que quieres eliminar el taller ' + workshop.name + '?'
    },
    confirmSave() {
      this.toast.loading = true
      const objc = JSON.parse(JSON.stringify(this.workshopEditObject))
      // objc.branch = this.getBranch
      this.$store
        .dispatch('workshop/deleteWorkshop', [objc])
        .then((response) => {
          this.toast.success = true
          this.toast.loading = false
          this.getWorkshops()
        })
        .catch((response) => {
          this.messageError = getMessageError(response.data)
          this.toast.failed = false
          this.toast.loading = false
        })
    },
    getInscriptionDate(workshop) {
      const d = moment(new Date()).format('yyyy-MM-DD') // d = "12/12/2017"
      const dateStart = moment(d + 'T' + workshop.timeSchedule).format()
      const dateEnd = moment(d + 'T' + workshop.timeEndSchedule).format()
      const text = 'Hora de la clase:'
      var startDate = ''
      var endDate = ''

      if (dateStart != null) {
        console.log(dateStart)
        startDate = moment(dateStart).format('hh:mm a')
      }

      if (dateEnd != null) {
        console.log(dateEnd)
        endDate = moment(dateEnd).format('hh:mm a')
      }
      return text + ' ' + startDate + ' - ' + endDate
    },
    getStatus(workshop) {
      // C-Created
      // P-Published (Abierto a Inscripciones)
      // D-Deleted
      // A-Activated (El cron lo cambia a este status)
      // I-Inactived (Cancelado, aplica cuando estaba activo)
      // F- Finished (El cron lo cambia a este status)
      switch (workshop.status) {
        case 'C':
          return 'Creado'
        case 'P':
          return 'Publicado'
        case 'A':
          return 'Activo'
        case 'I':
          return 'Inactivo'
        case 'F':
          return 'Terminado'
      }
      return ''
    },
    getWorkshops() {
      this.toast.loading = true
      if (this.getBranch.id == null) {
        return
      }
      let pageSize =
        this.pagination.rowsPerPage == -1
          ? this.totalNotices
          : this.pagination.rowsPerPage
      let currentPage = this.pagination.page - 1
      let offset = currentPage * pageSize
      const filter = {
        search: this.filters.search,
        tag: this.filters.tag,
        from: this.timeFirst,
        to: this.timeLast,
        courseStatus: this.getCourses(),
        classrooms: this.getClassRoomSelected(),
        employees: this.getEmployessSelected(),
        offset: offset,
        size: pageSize,
        orderBy: '',
        orderType: 'ASC',
      }
      this.$store
        .dispatch('workshop/getWorkshops', filter)
        .then((response) => {
          this.toast.loading = false
          this.workshops = response.data.entity
          this.totalWorkshops = response.data.size
        })
        .catch((response) => {
          this.messageError = getMessageError(response.data)
          this.toast.failed = false
          this.toast.loading = false
        })
    },
    getClassRoomSelected() {
      if (isEmptyOrNull(this.filters.classroom)) return []
      return [this.filters.classroom]
    },
    getEmployessSelected() {
      var employees = []
      let id = this.filters.employee
      if (!isEmptyOrNull(id)) {
        employees.push(id)
      }
      return employees
    },
    getCourses() {
      return this.filters.statusWorkshops
    },
    getDays(workshop) {
      const daysSplit = workshop.days.split(',')
      var daysString = ''
      ableDays.forEach((it) => {
        daysSplit.forEach((day) => {
          if (it.name === day) {
            daysString += it.nombre + ', '
          }
        })
      })
      return daysString
    },
    getEnrollmentData(workshop) {
      const quota = Number(workshop.quotaLimit)
      if (quota === 0) {
        return 'Sin límite'
      }

      const enrollment = Number(workshop.enrollment)
      // const percentage = enrollment * 100 / quota
      return 'Cupo: ' + enrollment + '/' + quota + ' Registrados'
    },
    closeCreateWorkshop() {
      this.getWorkshops()
    },
    filterSearchClear() {
      this.filters.search = ''
      this.getWorkshops()
    },
    filterSearchClearTag() {
      this.filters.tag = ''
      this.getWorkshops()
    },
    filterSearch() {
      this.getWorkshops()
    },
    filterDate() {
      this.getWorkshops()
    },
    allowedDatesF(val) {
      var date = new Date(val)
      date.setSeconds(0)
      date.setMinutes(0)
      date.setHours(0)

      var flag = false
      for (let t of this.allowedDates) {
        var date2 = new Date(t)
        date2.setSeconds(0)
        date2.setMinutes(0)
        date2.setHours(0)
        if (date2.getTime() === date.getTime()) {
          flag = true
        }
      }
      return true
    },
    allowedDatesF2(val) {
      var date = new Date(val)
      date.setSeconds(0)
      date.setMinutes(0)
      date.setHours(0)

      var flag = false
      for (let t of this.allowedDates2) {
        var date2 = new Date(t)
        date2.setSeconds(0)
        date2.setMinutes(0)
        date2.setHours(0)
        if (date2.getTime() === date.getTime()) {
          flag = true
        }
      }
      return true
    },
    filterStatus() {
      this.toast.loading = true
      clearTimeout(this.timer)

      const self = this
      this.timer = setTimeout(() => {
        self.toast.loading = false
        self.getWorkshops()
      }, 1000)
    },
    applyFilters(newFilters) {
      this.status = []
      this.status.push({ text: 'Creado', value: 'C' })
      this.status.push({ text: 'Publicado', value: 'P' })
      this.status.push({ text: 'Activado', value: 'A' })
      this.status.push({ text: 'Inactivo', value: 'I' })
      this.status.push({ text: 'Finalizado', value: 'F' })
      this.filters.statusWorkshops = this.defaultStatus
    },
    getEmployeeName(item) {
      if (isEmptyOrNull(item.employee)) {
        return ''
      }
      return (
        'Instructor: ' + item.employee.firstName + ' ' + item.employee.lastName
      )
    },
    getImage(item) {
      return item.image
    },
  },
}
</script>

<style>
.no-wrap {
  width: 200px !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.padding-flex {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

.my-workshop-toolbar {
  z-index: 1;
  height: 140px;
}

.my-workshop-toolbar .v-toolbar__content {
  height: 140px !important;
}

.card-workshop {
  height: 100% !important;
  border-radius: 20px !important;
  padding: 0% !important;
  margin: 10px !important;
  /* box-shadow: 0px 0px 1px 1px rgba(0, 0, 0, 0.2) !important */
}

.layout-workshop {
  height: 100%;
  border-radius: 20px;
  padding: 0% !important;
}

.image-content {
  border-radius: 20px;
  padding: 0% !important;
  background-color: rgb(255, 255, 255);
  display: block;
}

.image-parent {
  position: relative;
  height: 100%;
}

.image-view {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 20px;
}

.status-content {
  position: absolute;
  /* z-index: 1; */
  bottom: 0px;
  width: 100%;
  height: 40px;
  border-radius: 20px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  background-color: rgb(201, 201, 201);
}

.image-workshop {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  background: 50% no-repeat;
  background-size: cover;
}

.image-workshop-default {
  width: 100%;
  height: 100%;
  border-radius: 20px;
}

.data-content {
  padding: 10px !important;
}

.data-content-text {
  height: 70%;
}

.data-content-actions {
  height: 30%;
}

.title {
  color: black;
  font-weight: bold;
  font-size: large;
  text-align: left;
  width: 90%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.date {
  color: black;
  font-size: medium;
  text-align: left;
}

.subtitle-1 {
  font-size: small;
  color: black;
  text-align: left;
}

.subtitle-2 {
  font-size: small;
  color: black;
  text-align: left;
  font-weight: bold;
}

.description {
  font-size: small;
  color: black;
  text-align: left;
  font-weight: bold;
}

.center-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.full-content {
  width: 100%;
  height: 100% !important;
}

.icon {
  border-width: 1px;
  border-style: solid;
  border-color: gray;
  border-radius: 50%;
  padding: 5px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-content: center;
}

.my-nowrap {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%; /* some width */
}
</style>
